import { Frame } from '../Frame';

type EmbedProps = {
  attrs: {
    href: string;
  };
};

// Extract video ID from any Wistia URL
const WISTIA_REGEXES = [
  /^(https?:\/\/)?[a-zA-Z0-9-_~]+\.wistia\.com\/medias\/([a-zA-Z0-9-_~]+)\/?(\?.*)?$/i,
  /^(https?:\/\/)?[a-zA-Z0-9-_~]+\.wistia\.com\/embed\/iframe\/([a-zA-Z0-9-_~]+)\/?(\?.*)?$/i,
  /^(https?:\/\/)?[a-zA-Z0-9-_~]+\.wistia\.net\/embed\/iframe\/([a-zA-Z0-9-_~]+)\/?(\?.*)?$/i,
] as const;

export const Wistia = (props: EmbedProps): string | null => {
  // Extract video ID from the URL
  const matches = WISTIA_REGEXES.find((regex) => regex.test(props.attrs.href))?.exec(props.attrs.href);
  if (!matches) return null;

  // Get video ID from matches[2]
  const videoId = matches[2];
  if (!videoId) return null;

  // Extract domain from the URL for embed
  const url = new URL(props.attrs.href.startsWith('http') ? props.attrs.href : `https://${props.attrs.href}`);

  // Check if this is a custom domain (not fast.wistia.com or fast.wistia.net)
  const isCustomDomain = !url.hostname.startsWith('fast.wistia.');

  // Build embed URL with appropriate parameters
  const embedUrl = isCustomDomain
    ? `https://${url.hostname}/embed/iframe/${videoId}?seo=true&videoFoam=false`
    : `https://${url.hostname}/embed/iframe/${videoId}`;

  return Frame({
    src: embedUrl,
    border: true,
    title: `Wistia Embed (${videoId})`,
  });
};

// Add the isMatch function for Wistia
Wistia.isMatch = (href: string): boolean => {
  return WISTIA_REGEXES.some((regex) => regex.test(href));
};